/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { FC } from 'react';
import { styled } from 'linaria/lib/react';
import { theme } from '@mtsbank/ui-kit';
import { Payee } from '@root/api/ump-catalog-manager';
import { serviceTopClickGtm } from '@root/utils/gtm/cyber/events';
import { TileButton } from './buttons/TileButton';
type ServicesSwitcherTopMobileProps = {
  top?: Payee[];
};
export const ServicesSwitcherTopMobile: FC<ServicesSwitcherTopMobileProps> = ({
  top
}) => <ButtonGroup>
    <>
      {top?.slice(0, 6).map(serviceInfo => <TileButton slider key={serviceInfo?.serviceId} onClick={() => serviceTopClickGtm(serviceInfo.providerName)} title={serviceInfo?.providerName} icon={serviceInfo?.features?.tsp_picture_web}
    // merchant={serviceInfo?.features?.merchant_association_for_WEB}
    url={serviceInfo?.features?.tsp_url as string} />)}
    </>
  </ButtonGroup>;
const ButtonGroup = /*#__PURE__*/styled("div")({
  name: "ButtonGroup",
  class: "bxrkwqb"
});

require("./ServicesSwitcherTopMobile.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./ServicesSwitcherTopMobile.tsx");